export const getSession = () => {
    var stored_token = JSON.parse(localStorage.getItem("Login_Data"));
    return(
        stored_token
    );
}
